/** Chat attachment tiers (phase 1). English labels only. */

export const ATTACH_TIER_TEXT = 'text';
export const ATTACH_TIER_DOC = 'doc';
export const ATTACH_TIER_VISION_DOC = 'vision_doc';

export const ATTACH_TIER_OPTIONS = [
  { key: ATTACH_TIER_TEXT, value: ATTACH_TIER_TEXT, text: 'Text' },
  { key: ATTACH_TIER_DOC, value: ATTACH_TIER_DOC, text: 'Doc' },
  { key: ATTACH_TIER_VISION_DOC, value: ATTACH_TIER_VISION_DOC, text: 'Vision+Doc' },
];

export function normalizeAttachTier(tier) {
  const t = String(tier || '').toLowerCase().trim();
  if (t === ATTACH_TIER_DOC || t === 'document') return ATTACH_TIER_DOC;
  if (t === ATTACH_TIER_VISION_DOC || t === 'vision' || t === 'vision+doc') {
    return ATTACH_TIER_VISION_DOC;
  }
  return ATTACH_TIER_TEXT;
}

export function attachTierLabel(tier) {
  switch (normalizeAttachTier(tier)) {
    case ATTACH_TIER_DOC:
      return 'Doc';
    case ATTACH_TIER_VISION_DOC:
      return 'Vision+Doc';
    default:
      return 'Text';
  }
}

export function attachTierTooltip(tier) {
  switch (normalizeAttachTier(tier)) {
    case ATTACH_TIER_DOC:
      return 'Documents: .pdf, .docx, .pptx, .txt, .md, .csv, .json';
    case ATTACH_TIER_VISION_DOC:
      return 'Images: .png, .jpg, .webp; plus documents (.pdf, .docx, .pptx, .txt, .md, .csv, .json)';
    default:
      return 'Text files only: .txt, .md, .csv, .json';
  }
}

/** Normalize API available_models entry (string legacy or object). */
export function normalizeAvailableModelEntry(entry) {
  if (entry == null) return null;
  if (typeof entry === 'string') {
    const id = entry.trim();
    if (!id) return null;
    return {
      id,
      attach_tier: ATTACH_TIER_TEXT,
      attach_label: 'Text',
      attach_hint: attachTierTooltip(ATTACH_TIER_TEXT),
      billing_mode: 'token',
      chat_enabled: true,
      summary: '',
    };
  }
  const id = String(entry.id || '').trim();
  if (!id) return null;
  const tier = normalizeAttachTier(entry.attach_tier);
  const billingMode =
    entry.billing_mode === 'video_token' ? 'video_token' : 'token';
  const chatEnabled =
    entry.chat_enabled !== undefined ? !!entry.chat_enabled : billingMode !== 'video_token';
  return {
    id,
    attach_tier: tier,
    attach_label: entry.attach_label || attachTierLabel(tier),
    attach_hint: entry.attach_hint || attachTierTooltip(tier),
    billing_mode: billingMode,
    chat_enabled: chatEnabled,
    summary: String(entry.summary || '').trim(),
  };
}

function dropdownDescription(m) {
  const parts = [];
  if (m.summary) parts.push(m.summary);
  parts.push(m.attach_label);
  return parts.join(' · ');
}

export function modelDropdownOptions(entries) {
  return entries
    .map(normalizeAvailableModelEntry)
    .filter(Boolean)
    .map((m) => ({
      key: m.id,
      value: m.id,
      text: m.id,
      description: dropdownDescription(m),
    }));
}

export function lookupModelSummary(entries, modelId) {
  const id = String(modelId || '').trim();
  const hit = entries
    .map(normalizeAvailableModelEntry)
    .filter(Boolean)
    .find((m) => m.id === id);
  return hit?.summary || '';
}

export function lookupAttachTier(entries, modelId) {
  const id = String(modelId || '').trim();
  const hit = entries
    .map(normalizeAvailableModelEntry)
    .filter(Boolean)
    .find((m) => m.id === id);
  return hit ? hit.attach_tier : ATTACH_TIER_TEXT;
}

export function lookupChatEnabled(entries, modelId) {
  const id = String(modelId || '').trim();
  const hit = entries
    .map(normalizeAvailableModelEntry)
    .filter(Boolean)
    .find((m) => m.id === id);
  if (!hit) return true;
  return hit.chat_enabled !== false;
}
